import AddIcon from '@mui/icons-material/Add';
import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import WSButton from "../../Components/Button/WSButton";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSDataGridNew from "../../Components/DataGrid/WSDataGridNew";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../StateManagement/actions";
import { breadCrumbsStore } from '../../Components/BreadCrumbs/BreadCrumbsListner';
export const VendorTypeList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);

  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const filters = ['All Records'];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);
  useEffect(() => { updateMainHeader('Vendor Types'); }, [])


   breadCrumbsStore.updateBreadCrumbs([
              { 'Vendor Types': 'vendortype/list' },
  ]);
  
  const [source, setSource] = useState<any>({
    url: "VendorTypeMaster/search",
    page: 1,
    pageSize: 10,
    filter: [

    ],
    sort: [
      // {
      //     "field": "UpdatedAt",
      //     "direction": "desc"
      // }
    ],
  })

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/vendortype/edit/${row?.id}`);
    }

    if (action === "Delete") {
      setSelectedId(row.id); // Set the ID of the row to be deleted
      setPopupOpen(true);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Vendor Type",
      fieldName: "typeName",
      tooltip: true,
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];

  const handleClick = () => {
    navigate("/vendortype/add");
  };
  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("vendortypeGrid"));
    showMessage("Vendor Type deleted successfully!", "success");
  };
  const handleFilter = (value: any) => {
    let soureFilter: any = {
      url: "VendorTypeMaster/search",
      page: 1,
      pageSize: 10,
      filter: [
      ],
      sort: [
        // {
        //     "field": "UpdatedAt",
        //     "direction": "desc"
        // }
      ],
    }
    switch (value) {
      case 'In Stock':
        soureFilter.filter = [{
          "field": "name",
          "operator": "eq",
          "value": "In Stock"
        }]
        break

    }
    setSource({ ...soureFilter });
  }
  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item sm={9}>
          <WSFilterButtonGroup options={filters} selected={selectedFilter}
            onChange={(value) => {
              setSelectedFilter(value);
              handleFilter(value);
            }} />
        </Grid>
        <Grid item sm={3} display="flex" justifyContent={'flex-end'}>
          <WSButton id="btnAddNewProduct" label="Add Vendor Type" startIcon={<AddIcon />}
            onClick={handleClick}
            sx={{
              borderRadius: '999px',         // pill shape
              backgroundColor: '#098963!important',    // green background
              textTransform: 'none',         // prevent uppercase
              fontWeight: 500,
              height: '35px!important',
              fontSize: '0.875rem!important',
              paddingX: 3,
              paddingY: 1,
              '&:hover': {
                backgroundColor: '#087654!important',
              },
            }} />
        </Grid>
        <Grid item xs={12}>
          <WSDataGridNew
            id="vendortypeGrid"
            title="Vendor Type"
            columns={columns}
            source={source}
            searchBox={{ fieldName: 'typeName' }}
            addButton={{ label: "New", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
          {selectedId !== null && (
            <ConfirmationPopup
              type="DELETE"
              apiUrl={"VendorTypeMaster"}

              id={selectedId}
              confirmMessage="Are you sure you want to delete this item?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
});
